import React, {useState, useEffect} from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import './riderTripTable.scss'
import { db } from '../../firebase';
import { collection, getDocs, query, where } from 'firebase/firestore' 
import { Link } from 'react-router-dom'


const  RiderTripTable = ({riderId}) => {

//   const [ rows, setRows ] = useState([])

  const [ riderData, setRiderData ] = useState([])

//   useEffect(() => {
    
//     //LISTEN REAL TIME
    
//         onSnapshot(collection(db, "rider"), (snapShot) => {
//           let list = [];
//           snapShot.docs.forEach((doc) => {
//             list.push({ id: doc.id, ...doc.data()})
//           })
//           setRows(list)
//           // setIsLoading(false)
//           // console.log(data)
//         }, 
//           (error) => {
//             console.log(error)
//           }
//         ); 
     
//   },[])


useEffect(() => {
    
    //LISTEN REAL TIME

    const riderQuery = async() => {

      const riderRef = (collection(db, "riders"));
      const q = query(riderRef, where("riderId", "==", riderId));

      const querySnapshot = await getDocs(q);
        let list = []
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        list.push({id: doc.id, ...doc.data(), timeStamp: doc.data().timeStamp.toDate()})
        // console.log(doc.id, " => ", doc.data());
        console.log(list)

        setRiderData(list)
        // console.log(riderData)
      });

      // setriderData(doc.data())
      // console.log(riderData)

      console.log(riderData.timeStamp)

    }
    
    riderQuery()   
  },[])
 
  
  return (
    <TableContainer component={Paper} className="table">
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow className="tableRow"> 
           
            <TableCell className='tableCell'>Trip ID</TableCell>
            <TableCell className='tableCell'>Pickup </TableCell>
            {/* <TableCell className='tableCell'>ridered Date</TableCell> */}
            <TableCell className='tableCell'>Dropoff</TableCell>
            <TableCell className='tableCell'>Driver Name</TableCell>
            <TableCell className='tableCell'>Rider Name</TableCell>
            <TableCell className='tableCell'>Trip Fare</TableCell>
            <TableCell className='tableCell'>View</TableCell>
            {/* <TableCell className='tableCell'>Pickup time</TableCell>
            <TableCell className='tableCell'>Dropoff time</TableCell>
            // <TableCell className='tableCell'>Status</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {riderData.map((row) => (
            <TableRow key={row.id}  className="tableRow">
              
               <TableCell className='tableCell'>
                <span>{row.tripId}</span>
                </TableCell>
                <TableCell className='tableCell'>{row.pickup}</TableCell>
                <TableCell className='tableCell'>{row.dropoff}</TableCell>
                <TableCell className='tableCell'>{row.drivername}</TableCell>
                <TableCell className='tableCell'>{row.ridername}</TableCell>
                <TableCell className='tableCell'>N{row.fare}.00</TableCell>
                {/* <TableCell className='tableCell'>{row.pickuptime}</TableCell>
                <TableCell className='tableCell'>{row.dropofftime}</TableCell> */}
                <TableCell className='tableCell'>

                {row.status === 'RECEIVED_rider' && <div style={{ color:'green', padding:'10px', alignItems:'center', briderRadius:'5px', width:'100%' }}>PICKUP</div>} 
                {row.status === 'PROCESSING_rider' && <div  style={{ color:'orange', padding:'10px', alignItems:'center', briderRadius:'5px', width:'100%' }}>DROPOFF</div>} 
                {row.status === 'DELIVERING_rider' && <div  style={{color:'blue', padding:'10px', alignItems:'center', briderRadius:'5px', width:'100%' }}>COMPLETED</div>} 
                {row.status === 'DELIVERED_rider' && <div style={{color:'black', padding:'10px', alignItems:'center', briderRadius:'5px', width:'100%' }}>CANCELLED</div>} 
                {row.status === 'rider_COMPLETED' && <div style={{ color:'gray', padding:'10px', alignItems:'center', briderRadius:'5px', width:'100%' }}>COMPLETED rider</div>} 
                    
                </TableCell>
                <TableCell className='tableCell'>
                    <div style= {{padding:'5px', width:'30px', briderRadius:'5px', backgroundColor:'lightgray', color:'#666', briderWidth:'0.5px', justifyContent:'center'  }}>
                       <Link to={`/rides/${row.id}`} style={{textDecoration:"none"}}>
                          <div className="viewbutton">View</div>
                       </Link>
                    </div>
               </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default RiderTripTable